module.exports = __webpack_public_path__ + "static/media/vencimiento_rojo.888cf9ff.svg";